import { renderWithArrow } from "../utils";

const EvidenceCard = ({ diagnosis }) => {
  return (
    <div className="card">
      <h5>Evidence</h5>
      <div className="text-xs opacity-60 mt-1">
        Supporting facts behind the selected diagnosis.
      </div>
      {diagnosis ? (
        <>
          <div className="mt-2 font-semibold">{diagnosis.subject}</div>
          <div className="mt-2 text-xs opacity-70">Phenomenon</div>
          <div>{diagnosis.phenomenon}</div>
          <div className="mt-2 text-xs opacity-70">Hypothesis</div>
          <div>{diagnosis.hypothesis}</div>
          <div className="mt-2 text-xs opacity-70">Evidence</div>
          <div className="mt-1 space-y-1">
            {diagnosis.evidence.map((item) => (
              <div key={item}>
                - {renderWithArrow(item, `evidence-${item}`)}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="mt-2 opacity-60">No diagnosis selected.</div>
      )}
    </div>
  );
};

export default EvidenceCard;
